module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/about/james_moxley.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/about/james_moxley.jpg
// module id = TiXy
// module chunks = 0